import { render } from "./CustomerReviews.vue?vue&type=template&id=add96f5c"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__